module.exports = __webpack_public_path__ + "img/elasticbitcoin-A-REBASE-EVENT.b249fb5c.svg";